import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Icon } from 'antd';
import moment from 'moment';

export default class StudentInfo extends React.Component {
  render() {
    const { t, student } = this.props;

    return (
      <div>
        <div className="longtail-booking-details__block-row-container">
          <div className="tipbox">
            <Icon type="info-circle" style={{ color: '#6B92F3', marginRight: '8px' }} />
            <div className="tipbox__content">
              This section shows booking details from the initial snapshot, while the top header
              updates in real-time via S.com.
            </div>
          </div>
          <Row gutter={50} className="longtail-booking-details__block-row">
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.passport_first_name', {
                  value: student?.passportFirstName || '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.gender', {
                  value: student?.gender || '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.email', {
                  value: student?.emailAddress || '-',
                })}
              </p>
            </Col>
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.passport_last_name', {
                  value: student?.passportLastName ?? '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.date_of_birth', {
                  value: student?.dateOfBirth
                    ? moment(student?.dateOfBirth).format('DD/MM/YYYY')
                    : '-',
                })}
              </p>

              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.mobile', {
                  value: student?.phoneNumber || '-',
                })}
              </p>
            </Col>
          </Row>
        </div>
        <div className="longtail-booking-details__block-row-container">
          <Row gutter={50} className="longtail-booking-details__block-row">
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.country', {
                  value: student?.country || '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.city', {
                  value: student?.city || '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.address', {
                  value: student?.city || '-',
                })}
              </p>
            </Col>
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.state', {
                  value: student?.addressLines || '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.postal', {
                  value: student?.postalCode || '-',
                })}
              </p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

StudentInfo.propTypes = {
  t: PropTypes.func,
  student: PropTypes.object,
};

StudentInfo.defaultProps = {
  t: () => {},
  student: {},
};
